import React from "react";
import GreenHeader from "./GreenHeader";
import styles from "./howtoplay.module.css";
import { GameData } from "../containers/GameContainer";

function Howtoplay({ id }) {
  const {  how } = GameData[id-1];

  return (
    <div>
      <div className={styles.body}>
        <GreenHeader word={"วิธีเล่น"} />
        {how}
      </div>
    </div>
  );
}

export default Howtoplay;
